"use client";

import { MarkButton } from "@/components/tiptap-ui/mark-button/mark-button";
import { cn } from "@/lib/utils";
import { BubbleMenu, useCurrentEditor } from "@tiptap/react";
import React from "react";

export const BasicBubbleToolbar = ({ className }: { className?: string }) => {
  const { editor } = useCurrentEditor();

  if (!editor) {
    return null;
  }

  return (
    <BubbleMenu
      editor={editor}
      className={cn(
        "bg-background flex flex-row items-center gap-1 rounded-full border px-1 py-1 shadow-md",
        className,
      )}
      data-orientation="horizontal"
      shouldShow={({ state }) => {
        // Only show when there's a text selection
        const { selection } = state;
        const { empty } = selection;

        // Don't show if selection is empty
        if (empty) return false;

        return true;
      }}
    >
      <MarkButton type="bold" />
      <MarkButton type="italic" />
      <MarkButton type="underline" />
      <MarkButton type="code" />
    </BubbleMenu>
  );
};
